import React from 'react';
import { Path } from 'app/const/Path';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import { oneStopCss } from 'app/modules/web-shop/sub-modules/landing-module/components/our-shop-block/style';
import { ReactComponent as OneStopImg } from 'app/modules/web-shop/sub-modules/landing-module/components/our-shop-block/assets/OneshopImg.svg';

export function OneStopBlock() {
  return (
    <Container maxWidth="lg" css={oneStopCss}>
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={7} lg={6}>
          <h2>
            A one-stop destination for
            <br /> accessible and valuable open data.
          </h2>
          <p>
            Access the IATI Registry with ease, becoming a champion of
            <br />
            transparency in just a few clicks. Comply with donor <br />{' '}
            requirements by <b>
              publishing IATI-compliant information,
            </b> <br /> updating it as many times as needed with the help of our
            <br /> user-friendly templates.
          </p>
          <p>
            The AIDA Validator scans your data for any gaps or mistakes,
            <br />
            providing you with a report to enhance your information. The
            <br /> AIDA platform streamlines the process even further by <br />{' '}
            allowing you to <b>schedule publications</b> directly from your{' '}
            <br /> organization&apos;s Cloud folders and providing in-line
            feedback to
            <br />
            review any potential invalid data.
          </p>
          <p>
            Bring your data to life with the AIDA portal, which gathers all{' '}
            <br /> IATI data in the IATI Datastore and presents it through
            various
            <br />
            visualizations. Create <b>custom real-time dashboards</b> by <br />
            saving your searches and generating insightful reports with <br />{' '}
            eye-catching visuals for informed decision-making.
          </p>

          <p
            css={`
              border-bottom: 1px solid #2e4063;
              width: min-content;
              white-space: nowrap;
            `}
          >
            <Link to={Path.webshop.services}>Learn More</Link>{' '}
          </p>
        </Grid>
        <Grid item xs={12} md={7} lg={6}>
          <OneStopImg />
        </Grid>
      </Grid>
    </Container>
  );
}
